import React from "react";
import { Link } from 'react-router-dom';
import { LanguageSelector } from "./contexts/language-state/LanguageSelector";
import "../styles/NavMenu.css";

/**
 * Header component that displays the application title and language selector.
 * 
 * @returns {JSX.Element} The rendered header component.
 */
export function Header() {
  return (
    <header className="top-header-bar lnu-background">
      <Link to="/" className="link-style">
        <div className="left-header">
          <h1 className="left-header-title light-text no-margin">Sadima</h1>
          <p className="left-header-subtitle light-text no-margin">Språkstöd till mödrahälsovård</p>
        </div>
      </Link>
      <div className="language-container">
        <p className="medium-text">Patientens språk:</p>
        <LanguageSelector />
      </div>
    </header>
  );
}